var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M16.014 20.789l13.699-13.789 1.715 1.727-15.414 15.516-15.414-15.516 1.715-1.727z"}})}
var staticRenderFns = []

export { render, staticRenderFns }